import angular from 'angular';
import ContactSplitModal from './contactSplitModal';

export default angular
  .module('components.contactSplitModal', [])
  .component('contactSplitModal', ContactSplitModal).name;
